import MessengerModePage from '../components/pages/MessengerMode/MessengerModePage.vue'

export default [
  {
    path: '/messenger-mode/:translationId',
    name: 'messenger-mode',
    props: true,
    component: MessengerModePage,
    meta: {
      sideMenuDisabled: true
    }
  }
]
